
import * as actions from 'actions';

const INITIAL_STATE = {
  waitingToEnqueue: false,
  waitingToCancelEnqueue: false,
  isQueued: false,
  isActive: false,
  isOnline: false,
  unreadMessagesCount: 0,
  isWaitingForFeedback: false,
  isOpened: false,
  didOpenChat: false
};

export default (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case actions.CHAT_ENQUEUE:
      return {
        ...state,
        waitingToEnqueue: true,
        didOpenChat: false,
        isWaitingForFeedback: false,
        unreadMessagesCount: 0
      };

    case actions.CHAT_ENQUEUE_SUCCESS:
      return {
        ...state,
        isQueued: true,
        waitingToEnqueue: false
      };

    case actions.CHAT_ENQUEUE_ERROR:
      return {
        ...state,
        isQueued: false,
        waitingToEnqueue: false
      };

    case actions.CHAT_ENQUEUE_CANCEL:
      return {
        ...state,
        waitingToCancelEnqueue: true
      };

    case actions.CHAT_ENQUEUE_CANCEL_SUCCESS:
      return {
        ...state,
        waitingToCancelEnqueue: false,
        isQueued: false,
        isActive: false
      };

    case actions.CHAT_ENQUEUE_CANCEL_ERROR:
      return {
        ...state,
        waitingToCancelEnqueue: false,
        isQueued: true,
        isActive: false
      };

    case actions.CHAT_STATE_UPDATE: {
      const isActive = action.chatStateOnServer.activeChat;

      return {
        ...state,
        waitingToEnqueue: false,
        waitingToCancelEnqueue: false,
        isQueued: action.chatStateOnServer.queued,
        isOnline: action.chatStateOnServer.online,
        isActive,
        isWaitingForFeedback: state.isActive && !isActive
      };
    }

    case actions.CHAT_MESSAGES_UPDATE: {
      let unreadMessagesCount = state.unreadMessagesCount;

      if(!state.isOpened) {
        const chatMessagesById = action.result.entities.chatMessages;
        const chatMessagesFromCounsellor = Object
          .keys(chatMessagesById)
          .map(id => chatMessagesById[id])
          .filter(chatMessage => chatMessage.fromCounsellor);

        unreadMessagesCount += chatMessagesFromCounsellor.length;
      }

      return {
        ...state,
        unreadMessagesCount
      };
    }

    case actions.CHAT_WEBSITES_RECEIVED:
    case actions.CHAT_DOCUMENTS_RECEIVED:
    case actions.GOALS_RECEIVED:
    case actions.CHAT_QUESTIONNAIRES_RECEIVED: {
      if(action.type === actions.CHAT_QUESTIONNAIRES_RECEIVED) {
        if(action.result.chatQuestionnairesIds === 'eos') {
          return state;
        }
      }
      return {
        ...state,
        unreadMessagesCount: state.unreadMessagesCount + 1
      };
    }

    case actions.CHAT_QUESTIONNAIRE_SUBMIT_SUCCESS: {
      if(action.chatQuestionnaire.id === 'eos') {
        return {
          ...state,
          isWaitingForFeedback: false
        };
      }

      return state;
    }

    case actions.CHAT_OPEN:
      return {
        ...state,
        isOpened: true,
        didOpenChat: true,
        unreadMessagesCount: 0
      };

    case actions.CHAT_CLOSE:
      return {
        ...state,
        isOpened: false
      };

    default:
      return state;
  }
};



/** WEBPACK FOOTER **
 ** ./src/members/state/chat/state/reducer.js
 **/